export const diseases_9P_eng = [
    {
        label: 'Eczema',
        label_show: 'Eczema',
        page: 13,
        Xpos_image: '225px',
        Ypos_image: '540px',
        Xlabel: '245px',
        Ylabel: '630px',
        width: '79px',
        height: 'auto',
        result_comp: [
            { min: 1, max: 3, image: 'eczema_0' },
            { min: 4, max: 6, image: 'eczema_1' },
            { min: 7, max: 10, image: 'eczema_2' }
        ]
    },
    {
        label: 'Allergic rhinitis',
        label_show: 'Allergic Rhinitis',
        page: 13,
        Xpos_image: '360px',
        Ypos_image: '540px',
        Xlabel: '358px',
        Ylabel: '630px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'allergicrhiniitis_0' },
          { min: 4, max: 6, image: 'allergicrhiniitis_1' },
          { min: 7, max: 10, image: 'allergicrhiniitis_2' }
        ]
      },
    {
        label: 'Overweight',
        label_show: 'Obesity',
        page: 13,
        Xpos_image: '495px',
        Ypos_image: '540px',
        Xlabel: '515px',
        Ylabel: '630px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'overweight_0' },
          { min: 4, max: 6, image: 'overweight_1' },
          { min: 7, max: 10, image: 'overweight_2' }
        ]
      },
      {
        label: 'Constipation',
        label_show: 'Constipation',
        page: 13,
        Xpos_image: '225px',
        Ypos_image: '680px',
        Xlabel: '230px',
        Ylabel: '770px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'constipation_0' },
          { min: 4, max: 6, image: 'constipation_1' },
          { min: 7, max: 10, image: 'constipation_2' }
        ]
      },
      {
        label: 'Metabolic syndrome',
        label_show: 'Dyslipidemia',
        page: 13,
        Xpos_image: '360px',
        Ypos_image: '680px',
        Xlabel: '364px',
        Ylabel: '770px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'metabolicsyndrome_0' },
          { min: 4, max: 6, image: 'metabolicsyndrome_1' },
          { min: 7, max: 10, image: 'metabolicsyndrome_2' }
        ]
      },
      {
        label: 'Excessive lipopolysaccharide',
        label_show: ['Excessive', 'Lipopolysaccharide'],
        page: 13,
        Xpos_image: '495px',
        Ypos_image: '680px',
        Xlabel: '480px',
        Ylabel: '770px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'excessivelipopolysaccharide_0' },
          { min: 4, max: 6, image: 'excessivelipopolysaccharide_1' },
          { min: 7, max: 10, image: 'excessivelipopolysaccharide_2' }
        ]
      },
      {
        label: 'Insomnia/ poor sleep quality',
        label_show: ['Insomnia/ Poor', 'sleep quality'],
        page: 13,
        Xpos_image: '295px',
        Ypos_image: '820px',
        Xlabel: '290px',
        Ylabel: '910px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'insommnia_0' },
          { min: 4, max: 6, image: 'insommnia_1' },
          { min: 7, max: 10, image: 'insommnia_2' }
        ]
      },
      {
        label: 'Stress and anxiety',
        label_show: ['Stress and', 'Anxiety'],
        page: 13,
        Xpos_image: '430px',
        Ypos_image: '820px',
        Xlabel: '438px',
        Ylabel: '910px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'stress_0' },
          { min: 4, max: 6, image: 'stress_1' },
          { min: 7, max: 10, image: 'stress_2' }
        ]
      },
]


export const diseases_9P_thai = [
  {
      label: 'Eczema',
      label_show: 'ภูมิแพ้ผิวหนังอักเสบ',
      page: 12,
      Xpos_image: '225px',
      Ypos_image: '540px',
      Xlabel: '215px',
      Ylabel: '630px',
      width: '79px',
      height: 'auto',
      result_comp: [
          { min: 1, max: 3, image: 'eczema_0' },
          { min: 4, max: 6, image: 'eczema_1' },
          { min: 7, max: 10, image: 'eczema_2' }
      ]
  },
  {
      label: 'Allergic rhinitis',
      label_show: 'ภูมิแพ้อากาศ',
      page: 12,
      Xpos_image: '360px',
      Ypos_image: '540px',
      Xlabel: '365px',
      Ylabel: '630px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'allergicrhiniitis_0' },
        { min: 4, max: 6, image: 'allergicrhiniitis_1' },
        { min: 7, max: 10, image: 'allergicrhiniitis_2' }
      ]
    },
  {
      label: 'Overweight',
      label_show: 'น้ำหนักเกิน',
      page: 12,
      Xpos_image: '495px',
      Ypos_image: '540px',
      Xlabel: '508px',
      Ylabel: '630px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'overweight_0' },
        { min: 4, max: 6, image: 'overweight_1' },
        { min: 7, max: 10, image: 'overweight_2' }
      ]
    },
    {
      label: 'Constipation',
      label_show: 'ท้องผูก',
      page: 12,
      Xpos_image: '225px',
      Ypos_image: '680px',
      Xlabel: '245px',
      Ylabel: '770px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'constipation_0' },
        { min: 4, max: 6, image: 'constipation_1' },
        { min: 7, max: 10, image: 'constipation_2' }
      ]
    },
    {
      label: 'Metabolic syndrome',
      label_show: ['ไขมันในเลือด','ผิดปกติ'],
      page: 12,
      Xpos_image: '360px',
      Ypos_image: '680px',
      Xlabel: '367px',
      Ylabel: '770px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'metabolicsyndrome_0' },
        { min: 4, max: 6, image: 'metabolicsyndrome_1' },
        { min: 7, max: 10, image: 'metabolicsyndrome_2' }
      ]
    },
    {
      label: 'Excessive lipopolysaccharide',
      label_show: 'สาร Lipopolysaccharide สูง',
      page: 12,
      Xpos_image: '495px',
      Ypos_image: '680px',
      Xlabel: '466px',
      Ylabel: '770px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'excessivelipopolysaccharide_0' },
        { min: 4, max: 6, image: 'excessivelipopolysaccharide_1' },
        { min: 7, max: 10, image: 'excessivelipopolysaccharide_2' }
      ]
    },
    {
      label: 'Insomnia/ poor sleep quality',
      label_show: 'การนอนผิดปกติ',
      page: 12,
      Xpos_image: '295px',
      Ypos_image: '820px',
      Xlabel: '291px',
      Ylabel: '910px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'insommnia_0' },
        { min: 4, max: 6, image: 'insommnia_1' },
        { min: 7, max: 10, image: 'insommnia_2' }
      ]
    },
    {
      label: 'Stress and anxiety',
      label_show: 'ภาวะซึมเศร้าและเครียด',
      page: 12,
      Xpos_image: '430px',
      Ypos_image: '820px',
      Xlabel: '415px',
      Ylabel: '910px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'stress_0' },
        { min: 4, max: 6, image: 'stress_1' },
        { min: 7, max: 10, image: 'stress_2' }
      ]
    },
]

export const diseases_image_9P_eng = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];

export const diseases_image_9P_thai = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];